// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //LOCAL
  // backendService: 'https://i7yfff3dgd.execute-api.us-east-1.amazonaws.com/qas/',
  // backendServiceHerramientaAlmacen: 'http://127.0.0.1:3000'
  //backendServiceHerramientaAlmacen2: 'http://127.0.0.1:3000',
  //SANDBOX
  // backendService: 'https://api-heal.sbx.ransaaplicaciones.com/',
  // backendServiceHerramientaAlmacen:'https://api-samsung-test-v2.sbx.ransaaplicaciones.com',
  //DEV
  // backendService: 'https://09yzm4nxu4.execute-api.us-east-1.amazonaws.com/qas/',
  //QAS
  // backendService: 'https://r5dwwohgjh.execute-api.us-east-1.amazonaws.com/qas/',
  // backendServiceHerramientaAlmacen: 'https://api-almacen.qas.ransaaplicaciones.com',
  // backendServiceHerramientaAlmacen2: 'https://api-almacen2.qas.ransaaplicaciones.com',
  // backendServiceComexMant: 'https://qxupvg4z02.execute-api.us-east-1.amazonaws.com/qas', //  SUMMIT FASE 2 - api4 (mantenimientos COMEX: clientes-destinos, operador-portuario, transportista/by-ruc) - @author Miguel Licla
  // backendServiceComex: 'https://api-comex.qas.ransaaplicaciones.com', // SUMMIT FASE 1 - host del servicio de consulta de DAM por orden de aduana (QAS; en prod cambia el host) - @author Miguel Licla
  // backendServiceGuiaRemitente: 'https://l5rwkzozie.execute-api.us-east-1.amazonaws.com/Prod',
  // backendServicePedidosDwl: 'https://eqilm3omh3fjltudclowk4fzjm0iqsch.lambda-url.us-east-1.on.aws/',
  // backendServiceReportePreview: 'https://api-almacen.ransaaplicaciones.com',
  // backendServiceInforInventario: 'https://infor-inventario.qas.ransaaplicaciones.com/'
  //PRD
  backendService: 'https://i7yfff3dgd.execute-api.us-east-1.amazonaws.com/qas/',
  backendServiceHerramientaAlmacen: 'https://api-almacen.ransaaplicaciones.com',
  backendServiceHerramientaAlmacen2: 'https://api-almacen2.ransaaplicaciones.com',
  backendServiceComexMant: 'https://gczejim4vd.execute-api.us-east-1.amazonaws.com/prd', //  SUMMIT FASE 2 - api4 (mantenimientos COMEX: clientes-destinos, operador-portuario, transportista/by-ruc) - @author Miguel Licla
  backendServiceComex: 'https://api-comex.ransaaplicaciones.com',
  backendServiceReportePreview: 'https://szgeufsaxvrjxztwk5ejxq47ti0wnhzn.lambda-url.us-east-1.on.aws/',
  backendServicePedidosDwl: 'https://zketwngkr55jtrqorhd76zt5yy0vgfaf.lambda-url.us-east-1.on.aws/',
  backendServiceInforInventario: 'https://infor-inventario.ransaaplicaciones.com/',



  // backendService: 'https://sf4m87r1p1.execute-api.us-east-1.amazonaws.com/qas/',
  // backendService: 'https://api-heal.sbx.ransaaplicaciones.com/',
  // backendServiceHerramientaAlmacen: 'https://apihad.lotfwaredev.applying.dev'
  //backendService: 'https://t6fwb2o6rj.execute-api.us-east-1.amazonaws.com/dev/'
  //backendService: 'https://sgzk8pqkag.execute-api.us-east-1.amazonaws.com/test/'
  //backendService: 'https://2bvmc0zn3e.execute-api.us-east-1.amazonaws.com/qas/'
  //'https://jhxpo2v9w8.execute-api.us-east-1.amazonaws.com/test/'
  // https://ux6irrkiue.execute-api.us-east-1.amazonaws.com
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
